import {
    URL_DASHBOARD,
    URL_SUB_ADMIN,
    URL_USER,
    URL_PRIEST_USER,
    // URL_BANNER,
    URL_TEMPLE,
    URL_PRODUCT_CATEGORY,
    URL_PRODUCT_ITEM,
    URL_CHANGE_PASSWORD,
    URL_STATIC_PAGE,
    URL_PROFILE,
    URL_COMMISSION,
    URL_PROMO_CODE,
    SATVIK_FOOD_ORDER,
    CONTACT_US_FORM_DATA,
    EMAIL_TEMPLATES,
    PAYOUT_REQUESTS,
    URL_PRIEST_USER_REQUEST,
    URL_BLOCKED_USER,
    URL_REPORTED_POST,
    URL_NORMAL_USER_POST,
    URL_REPORTED_COMMENTS,
    URL_REPORTED_PROFILE,
    URL_VISIT_MANAGEMENT,
    URL_ITINERY_MANAGEMENT,
    URL_DHAM_MANAGEMENT,
    URL_HOTELS_MANAGEMENT,
    URL_TAXI_TRANSFER,
    URL_BOOK_RIDE,
    URL_GUIDE_MANAGEMENT,
    URL_ACTIVITIES_MANAGEMENT,
    URL_DRIVERS,
    URL_DHAM_MANAGEMENT_REQUESTS,
    URL_BOOK_GUIDE,
    URL_FOOD_CATEGORY,
    URL_FOOD_ITEM,
    URL_FOOD_RESTAURANT_RANGE,
    URL_TEMPLE_MANAGEMENT,
    URL_POOJA_MANAGEMENT,
    URL_SHOP_RANGE,
    PRASADAM_ORDER,
    REQUESTS_FOR_PAYOUT,
    URL_KATHAKAR,
    URL_KATHA,
    URL_PUJARI,
    URL_POOJA_CEREMONY,
    URL_POOJA_PACKAGE,
    URL_BOOKINGS_KATHA_POOJA,
    URL_VENDOR_USER,
    DIVINE_SHOP_ORDER,
    URL_RESTAURANT,
    URL_TEMPLE_SLOT_BOOKINGS,
    URL_REPORTS,
    COMMUNITY_USERS
} from 'Helpers/Paths';

import GridViewIcon from '@mui/icons-material/GridView';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import ReportIcon from '@mui/icons-material/Report';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
// import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import TempleBuddhistOutlinedIcon from '@mui/icons-material/TempleBuddhistOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MailIcon from '@mui/icons-material/Mail';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
// import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import PagesOutlinedIcon from '@mui/icons-material/PagesOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import ClosedCaptionOutlinedIcon from '@mui/icons-material/ClosedCaptionOutlined';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import PeopleIcon from '@mui/icons-material/People';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import HotelIcon from '@mui/icons-material/Hotel';
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import StorefrontIcon from '@mui/icons-material/Storefront';
import FestivalIcon from '@mui/icons-material/Festival';
import TourIcon from '@mui/icons-material/Tour';
import NavigationIcon from '@mui/icons-material/Navigation';
import BentoIcon from '@mui/icons-material/Bento';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import TakeoutDiningIcon from '@mui/icons-material/TakeoutDining';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ClassIcon from '@mui/icons-material/Class';
import FilterVintageIcon from '@mui/icons-material/FilterVintage';
import CelebrationIcon from '@mui/icons-material/Celebration';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import EmojiPeopleOutlinedIcon from '@mui/icons-material/EmojiPeopleOutlined';
import SelfImprovementOutlinedIcon from '@mui/icons-material/SelfImprovementOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';

/**
 * @constant
 * @description Comprehensive menu configuration for the Devotee CMS admin panel sidebar navigation.
 * Defines the complete menu structure with nested submenus, icons, routes, and permission mappings.
 *
 * Menu Structure:
 * - **Dashboard**: Main dashboard with analytics and overview
 * - **Admin**: Sub-admin management and permissions
 * - **Users**: Complete user management across all user types
 * - **Orders**: Order management for all business modules
 * - **Satvik Food**: Food delivery management
 * - **Prasadam Booking**: Temple prasadam delivery system
 * - **Divine Shop**: E-commerce product management
 * - **Temple**: Temple management and slot bookings
 * - **Dham Yatra**: Pilgrimage travel management
 * - **Katha Management**: Spiritual storytelling events
 * - **Pooja Management**: Religious ceremony management
 * - **Community**: User-generated content and social features
 * - **Reports**: Analytics and business intelligence
 * - **Settings**: System configuration and management
 *
 * Key Features:
 * - **Hierarchical Structure**: Multi-level menu organization with parent-child relationships
 * - **Permission Integration**: Each menu item linked to specific permission modules
 * - **Icon Association**: Material-UI icons for visual identification
 * - **Route Mapping**: Direct mapping to React Router routes
 * - **Submenu Support**: Nested submenu structures for complex navigation
 * - **Modular Design**: Easy to extend and modify menu structure
 * - **Business Logic Integration**: Organized by business functional areas
 *
 * Menu Item Structure:
 * - **name**: Display name for the menu item
 * - **icon**: Material-UI icon component for visual representation
 * - **path**: React Router route path for navigation
 * - **permissionName**: Permission module name for access control
 * - **submenu**: Array of child menu items (optional)
 * - **state**: Navigation state to pass to router (optional)
 *
 * Permission Modules:
 * - DASHBOARD: Dashboard access and analytics
 * - USER: User management across all types
 * - ORDERS: Order management and processing
 * - SATVIK_FOOD: Food delivery system
 * - PRASADAM_BOOKING: Temple prasadam delivery
 * - DIVINE_SHOP: E-commerce product management
 * - TEMPLE: Temple management and bookings
 * - DHAM_YATRA: Pilgrimage travel services
 * - KATHA_MANAGEMENT: Spiritual storytelling events
 * - POOJA_MANAGEMENT: Religious ceremony management
 * - COMMUNITY: Social features and content moderation
 * - REPORTS: Analytics and reporting
 * - SETTINGS: System configuration
 *
 * @type {Array<Object>}
 *
 * @example
 * // Usage in sidebar component
 * import { MenuList } from './data';
 *
 * const processedMenuList = MenuList.map(menu => ({
 *   ...menu,
 *   isVisible: checkPermission(menu.permissionName)
 * }));
 *
 * @example
 * // Accessing menu structure
 * const userManagementMenu = MenuList.find(menu => menu.name === 'Users');
 * const devoteeSubmenu = userManagementMenu.submenu.find(sub => sub.name === 'Devotee');
 *
 * @example
 * // Adding new menu item
 * const newMenuItem = {
 *   name: 'New Feature',
 *   icon: NewIcon,
 *   path: '/new-feature',
 *   permissionName: 'NEW_FEATURE'
 * };
 * MenuList.push(newMenuItem);
 *
 * @see Sidebar - Component that uses this menu configuration
 * @see MenuCard - Component that renders individual menu items
 * @see useFindPermission - Hook for checking menu permissions
 * @see URL_* - Route constants imported from Helpers/Paths
 */
export const MenuList = [
    {
        name: 'Dashboard',
        icon: GridViewIcon,
        path: URL_DASHBOARD,
        permissionName: 'DASHBOARD'
    },
    {
        name: 'Admin',
        icon: VerifiedUserOutlinedIcon,
        path: URL_SUB_ADMIN
    },
    {
        name: 'Users',
        icon: GroupOutlinedIcon,
        permissionName: 'USER',
        submenu: [
            {
                name: 'Devotee',
                icon: PersonOutlinedIcon,
                path: URL_USER
            },
            {
                name: 'Driver',
                icon: DirectionsCarOutlinedIcon,
                path: URL_DRIVERS
            },
            {
                name: 'Guide',
                icon: EmojiPeopleOutlinedIcon,
                path: URL_GUIDE_MANAGEMENT
            },
            {
                name: 'Spiritual Leader',
                icon: SelfImprovementOutlinedIcon,
                path: URL_KATHAKAR
            },
            {
                name: 'Priest',
                icon: FilterVintageIcon,
                path: URL_PRIEST_USER
            },
            {
                name: 'Vendor',
                icon: StorefrontOutlinedIcon,
                path: URL_VENDOR_USER
            },
            {
                name: 'Priest User Requests',
                icon: AssignmentIndOutlinedIcon,
                path: URL_PRIEST_USER_REQUEST
            }
        ]
    },
    // {
    //     name: 'Banners',
    //     icon: PermMediaOutlinedIcon,
    //     path: URL_BANNER,
    //     permissionName: 'BANNER'
    // },
    {
        name: 'Orders',
        icon: ReceiptIcon,
        permissionName: 'ORDERS',
        submenu: [
            {
                name: 'Satvik food',
                icon: LocalDiningIcon,
                path: SATVIK_FOOD_ORDER
            },
            {
                name: 'Prasadam Delivery',
                icon: DeliveryDiningIcon,
                path: PRASADAM_ORDER
            },
            {
                name: 'Divine Shop',
                icon: LocalMallIcon,
                path: DIVINE_SHOP_ORDER
            }
        ]
    },
    {
        name: 'Satvik Food',
        icon: LocalDiningIcon,
        permissionName: 'SATVIK_FOOD',
        submenu: [
            {
                name: 'Food Category',
                icon: SummarizeIcon,
                path: URL_FOOD_CATEGORY
            },
            {
                name: 'Food Item',
                icon: BentoIcon,
                path: URL_FOOD_ITEM
            },
            {
                name: 'Restaurant',
                path: URL_RESTAURANT,
                icon: RestaurantIcon
            },
            {
                name: 'Restaurant Range',
                icon: NavigationIcon,
                path: URL_FOOD_RESTAURANT_RANGE
            }
        ]
    },
    {
        name: 'Community',
        icon: PeopleIcon,
        permissionName: 'COMMUNITY',
        submenu: [
            {
                name: 'Community Users',
                icon: PeopleIcon,
                path: COMMUNITY_USERS
            },
            {
                name: 'Blocked Users',
                icon: PersonOffIcon,
                path: URL_BLOCKED_USER
            },
            {
                name: 'User Post',
                icon: ContactPageIcon,
                path: URL_NORMAL_USER_POST
            },
            {
                name: 'Reported Post',
                icon: ReportIcon,
                path: URL_REPORTED_POST
            },
            {
                name: 'Reported Comments',
                icon: CommentsDisabledIcon,
                path: URL_REPORTED_COMMENTS
            },
            {
                name: 'Reported Profile',
                icon: NoAccountsIcon,
                path: URL_REPORTED_PROFILE
            }
        ]
    },
    {
        name: 'Darshan Booking',
        icon: TempleBuddhistOutlinedIcon,
        permissionName: 'DARSHAN_BOOKING',
        submenu: [
            {
                name: 'Temples',
                icon: TempleBuddhistOutlinedIcon,
                path: URL_TEMPLE
            },
            {
                name: 'Bookings',
                icon: ReceiptIcon,
                path: URL_TEMPLE_SLOT_BOOKINGS
            }
        ]
    },
    {
        name: 'Divine Shop',
        icon: StorefrontIcon,
        permissionName: 'DIVINE_SHOP',
        submenu: [
            {
                name: 'Product Category',
                icon: CategoryOutlinedIcon,
                path: URL_PRODUCT_CATEGORY
            },
            {
                name: 'Product Item',
                icon: FormatListBulletedOutlinedIcon,
                path: URL_PRODUCT_ITEM
            },
            {
                name: 'Shop Range',
                icon: TourIcon,
                path: URL_SHOP_RANGE
            }
        ]
    },
    {
        name: 'Pooja Management',
        icon: FilterVintageIcon,
        permissionName: 'POOJA_MANAGEMENT',
        submenu: [
            // {
            //     name: 'Pooja Management',
            //     icon: FestivalIcon,
            //     path: URL_POOJA_MANAGEMENT
            // },
            {
                name: 'Pooja Service',
                icon: CelebrationIcon,
                path: URL_POOJA_CEREMONY
            },
            {
                name: 'Pandit',
                icon: PersonOutlinedIcon,
                path: URL_PUJARI
            },
            {
                name: 'Pooja Package',
                icon: Inventory2Icon,
                path: URL_POOJA_PACKAGE
            },
            {
                name: 'Requests',
                icon: BubbleChartIcon,
                path: URL_BOOKINGS_KATHA_POOJA,
                state: { view_type: 'pooja' }
            }
        ]
    },
    {
        name: 'Divine Events',
        icon: AutoStoriesIcon,
        permissionName: 'KATHA_MANAGEMENT',
        submenu: [
            {
                name: 'Divine Events',
                icon: ClassIcon,
                path: URL_KATHA
            },

            {
                name: 'Requests',
                icon: BubbleChartIcon,
                path: URL_BOOKINGS_KATHA_POOJA,
                state: { view_type: 'divine_event' }
            }
        ]
    },
    {
        name: 'Dham Yatra',
        icon: AirportShuttleIcon,
        permissionName: 'DHAM_YATRA',
        submenu: [
            {
                name: 'Requests',
                icon: BubbleChartIcon,
                path: URL_DHAM_MANAGEMENT_REQUESTS
            },
            {
                name: 'Dham Management',
                icon: FestivalIcon,
                path: URL_DHAM_MANAGEMENT
            },
            {
                name: 'Visit Management',
                icon: TourIcon,
                path: URL_VISIT_MANAGEMENT
            },
            {
                name: 'Itinerary Management',
                icon: LocationOnIcon,
                path: URL_ITINERY_MANAGEMENT
            },
            {
                name: 'Hotels Management',
                icon: HotelIcon,
                path: URL_HOTELS_MANAGEMENT
            },
            {
                name: 'Taxi Transfer',
                icon: LocalTaxiIcon,
                path: URL_TAXI_TRANSFER
            },
            {
                name: 'Book Ride',
                icon: NoCrashIcon,
                path: URL_BOOK_RIDE
            },
            {
                name: 'Book Guide',
                icon: InterpreterModeIcon,
                path: URL_BOOK_GUIDE
            },
            {
                name: 'Activities Mangement',
                icon: LocalActivityIcon,
                path: URL_ACTIVITIES_MANAGEMENT
            }
        ]
    },
    {
        name: 'Prasadam Booking',
        icon: TakeoutDiningIcon,
        permissionName: 'PRASADAM_BOOKING',
        submenu: [
            {
                name: 'Temple Management',
                icon: SocialDistanceIcon,
                path: URL_TEMPLE_MANAGEMENT
            },
            {
                name: 'Pooja Prasadam Management',
                icon: FestivalIcon,
                path: URL_POOJA_MANAGEMENT
            }
        ]
    },
    {
        name: 'Convenience',
        icon: PercentOutlinedIcon,
        path: URL_COMMISSION,
        permissionName: 'COMMISSION'
    },
    {
        name: 'Promo Code',
        icon: ClosedCaptionOutlinedIcon,
        path: URL_PROMO_CODE,
        permissionName: 'PROMO_CODE'
    },
    {
        name: 'Static Pages',
        icon: PagesOutlinedIcon,
        path: URL_STATIC_PAGE,
        permissionName: 'STATIC_PAGES'
    },
    {
        name: 'Settings',
        icon: SettingsOutlinedIcon,
        submenu: [
            {
                name: 'Edit Profile',
                icon: AccountCircleOutlinedIcon,
                path: URL_PROFILE
            },
            {
                name: 'Change Password',
                icon: LockOpenOutlinedIcon,
                path: URL_CHANGE_PASSWORD
            }
            // {
            //     name: 'Rating & Feedback',
            //     icon: StarOutlinedIcon,
            //     path: '#'
            // }
        ]
    },
    {
        name: 'Payout Requests',
        icon: CurrencyRupeeIcon,
        path: PAYOUT_REQUESTS,
        permissionName: 'PAYOUT_REQUESTS'
    },
    {
        name: 'Requests For Payout',
        icon: CurrencyRupeeIcon,
        path: REQUESTS_FOR_PAYOUT,
        permissionName: 'REQUESTS_FOR_PAYOUT'
    },
    {
        name: 'Email Templates',
        icon: MailIcon,
        path: EMAIL_TEMPLATES
    },
    {
        name: 'ContactUs Form Data',
        icon: RecentActorsIcon,
        path: CONTACT_US_FORM_DATA
    },
    {
        name: 'Reports',
        icon: SummarizeIcon,
        path: URL_REPORTS,
        permissionName: 'REPORTS'
    }
];
